import { SettingsPage } from "@/features/settings";

/** Route /:lang/settings: the contributor's profile and settings. */
export default function Settings() {
  return <SettingsPage />;
}
